"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSequenceAdapter = isSequenceAdapter;
exports.isRegionsAdapter = isRegionsAdapter;
exports.isFeatureAdapter = isFeatureAdapter;
exports.isRefNameAliasAdapter = isRefNameAliasAdapter;
exports.isTextSearchAdapter = isTextSearchAdapter;
function isSequenceAdapter(t) {
    return 'getRegions' in t && 'getFeatures' in t;
}
function isRegionsAdapter(t) {
    return 'getRegions' in t;
}
function isFeatureAdapter(t) {
    return 'getFeatures' in t;
}
function isRefNameAliasAdapter(t) {
    return 'getRefNameAliases' in t;
}
function isTextSearchAdapter(t) {
    return 'searchIndex' in t;
}
